export default {
  header: 'You won a Best of Booksy Award!',
  btn: 'Share as social post',
  'subtitle-1': 'How does it work?',
  'text-1': 'You work hard, and every once in a while it’s nice to feel noticed. That’s the essence behind our Best of Booksy Awards to celebrate you. The dreamers and doers that inspire us to do more, and do it best.',
  'subtitle-2': 'We have made your salon even more visible!',
  'subtitle-small-1': 'A Search Results Badge',
  'text-2': 'Now anyone searching Booksy will know you\'re crushing the competition.',
  'subtitle-small-2': 'A Business Profile Badge',
  'text-3': 'Let everyone know about your success with a new Badge on your Profile Picture.',
  'subtitle-3': 'Award types',
  'award-type-1': {
    title: 'Most Buzz',
    subtitle: 'Awarded to those with the most and best reviews.',
  },
  'award-type-2': {
    title: 'Greatest Loyalty',
    subtitle: 'Recognizing businesses with the most returning customers.',
  },
  'award-type-3': {
    title: 'Most Booked',
    subtitle: 'Elevating those with the most customer bookings.',
  },
  'award-type-4': {
    title: 'Best Portfolio',
    subtitle: 'Highlighting businesses with the most portfolio photos.',
  },
  'award-type-5': {
    title: 'Busiest',
    subtitle: 'Celebrating those with the fullest calendars.',
  },
}
